import {
    useMediator,
    useNotifications,
    ConfirmationPrompt,
    useRouter,
    useEffectAfterMount,
    useRelodeAppUI,
    mediator,
} from "@relode/core";
import * as React from "react";
import { AddJobForm } from "./_infra/addJobForm";
import { AddJobWrapper } from "./add/addJobWrapper";
import { useAddJobContext } from "./_infra";
import { JobManagerContact } from "../../shared/types";
import { AddJobSeedData } from "./types";

export const AddJobContainer = () => {
    const [showAddJob, setShowAddJob] = React.useState<boolean>(false);
    const [selectedJobId, setSelectedJobId] = React.useState<number>();
    const [seedData, setSeedData] = React.useState<AddJobSeedData>(undefined);
    const [isEditJob, setIsEditJob] = React.useState(false);
    const [onComplete, setOnComplete] = React.useState<() => void>(undefined);
    const [parentPageTitle, setParentPageTitle] = React.useState(undefined);
    const { actions: notifications } = useNotifications();
    const { ui: appUIState } = useRelodeAppUI();

    useEffectAfterMount(() => {
        setShowAddJob(false);
    }, [location.pathname, location.search]);

    useMediator("showAddJob", data => {
        setSelectedJobId(data?.jobId);
        setIsEditJob(data?.isEditJob);
        setOnComplete(() => data?.onComplete);
        setParentPageTitle(appUIState.pageTitle);
        setShowAddJob(true);
        notifications.closeAllAreaNotifications();
        setSeedData(data?.seedData);
    });

    const handleClose = () => {
        appUIState.actions.setPageTitle(parentPageTitle);
        setShowAddJob(false);
        onComplete?.();
    };

    return showAddJob ? (
        <AddJobForm seedData={seedData}>
            <AddJob
                show={showAddJob}
                onClose={handleClose}
                selectedJobId={selectedJobId}
                isEditJob={isEditJob}
                seedData={seedData}
            />
        </AddJobForm>
    ) : null;
};

const AddJob = (props: {
    show: boolean;
    onClose: () => void;
    selectedJobId: number;
    isEditJob: boolean;
    seedData?: AddJobSeedData;
}) => {
    const { history, location } = useRouter();
    const { formikProps } = useAddJobContext();

    const { dirty } = formikProps;

    const handleConfirmationNavigation = (
        pathname: string,
        shouldSaveFirst: boolean
    ) => {
        props.onClose();
        history.push(pathname, location.state);
    };

    const handleSaveAndExit = (jobId: number) => {
        props.onClose();
        history.push(`/jobs/${jobId}`);
    };

    const handleFinish = (
        jobId: number,
        jobName: string,
        jobManagerContact: JobManagerContact
    ) => {
        mediator.send("showAddNewJobConfirmation", {
            jobId: jobId,
            jobName: jobName,
            jobManagerContact: jobManagerContact,
        });
        props.onClose();
        history.push(`/jobs/${jobId}`);
    };

    return (
        <>
            <ConfirmationPrompt
                when={dirty}
                navigate={handleConfirmationNavigation}
                shouldBlock={l => dirty && !props.show}
                canSave={false}
            />

            <AddJobWrapper
                handleClose={props.onClose}
                selectedJobId={props.selectedJobId}
                isEditJob={props.isEditJob}
                onSaveAndExit={handleSaveAndExit}
                onFinish={handleFinish}
                seedData={props.seedData}
            ></AddJobWrapper>
        </>
    );
};
